export default {
  beforeList: ({ form }) => {
    ;
  },
};
